export default link => ['http', 'www'].some(prefix => link.startsWith(prefix));
